import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import { v4 as uuidv4 } from "uuid";

// import { setSortByValue } from "SearchResults/SearchSlice";
import { setSelectedCategoryTagId } from "../../redux/features/landingSlice";
import "pure-react-carousel/dist/react-carousel.es.css";
import ColletionsSuccessModal from "./CollectionModal";

import Item from "./Item";

function RecentlyViewed({
  recentlyViewedList,
  leftArrow,
  rightArrow,
  title,
  titleVisible,
}) {
  const [isCollect, setIsCollect] = useState(false);
  const [collectedItem, setCollectedItem] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onViewMore = () => {
    localStorage.removeItem("item_search_data");
    dispatch(setSelectedCategoryTagId(null));
    // dispatch(setSortByValue("Recently Viewed"));
    navigate(`/searchResults`, {state:{sortBy:"Recently Viewed"}});
  };

  const onCollectDismiss = () => {
    dispatch(setSelectedCategoryTagId(null));
    setIsCollect(false);
  };
  return (
    <>
      <ColletionsSuccessModal
        isOpen={isCollect}
        onClose={onCollectDismiss}
        collectedItem={collectedItem}
      />
      {titleVisible ? (
        <div className="span12 margin-top">
          <div className="view-more">
            <span className="pointer" onClick={onViewMore}>
              View More
            </span>
          </div>

          <h2 className="black">
            <strong>{title}</strong>
          </h2>

          <div>
            <div className="tile-scroll">
              <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={490}
                totalSlides={recentlyViewedList.length}
                visibleSlides={4}
                infinite={true}
                style={{ position: "relative" }}
              >
                <Slider style={{ height: "490px" }}>
                  {recentlyViewedList.map((itemData) => (
                    <Slide key={uuidv4()}>
                      <Item
                        itemData={itemData}
                        setIsCollect={setIsCollect}
                        setCollectedItem={setCollectedItem}
                      />
                    </Slide>
                  ))}
                </Slider>
                <ButtonBack
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "-35px",
                    background: "none",
                    border: "none",
                  }}
                >
                  <img src={leftArrow} />
                </ButtonBack>
                <ButtonNext
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "-35px",
                    background: "none",
                    border: "none",
                  }}
                >
                  <img src={rightArrow} />
                </ButtonNext>
              </CarouselProvider>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default RecentlyViewed;
